import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { IApiCommitmentStatus } from './models/apiCommitmentStatus'

export interface IFetchAcknowledgementItems {
  partnerId: string
  fYear: number
  ownerId: string
}

export async function fetchCommitmentStatuses({
  partnerId,
  fYear,
  ownerId,
}: IFetchAcknowledgementItems): Promise<IApiCommitmentStatus[]> {
  const url = proxy('/webservice/621/sp/v3/spJBPCommitmentStatus/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.ProgramType': ProgramTypes.None,
  }
  const response = await Rest.post({ url, payload, headers })
  return response.Rows ?? []
}
